import type { PropsWithChildren } from "react";

import { ViewBarSettingsContext, type ViewBarSettings } from "./ViewBarSettingsContext";

const ROOT = "viewBar";

type Props = {
  moduleId: string;
  useStickyState: <T>(name: string, initialState: T) => [T, (_: T) => void, () => void];
};

export const ViewBarSettingsProvider = ({ moduleId, useStickyState, children }: PropsWithChildren<Props>) => {
  const [showGoals, setShowGoals, removeShowGoals] = useStickyState<ViewBarSettings["showGoals"]>(
    `${moduleId}_${ROOT}_showGoals`,
    true,
  );

  return (
    <ViewBarSettingsContext.Provider value={{ showGoals, setShowGoals, removeByIdViewBarSettings: removeShowGoals }}>
      {children}
    </ViewBarSettingsContext.Provider>
  );
};
